/**
 * CDN Configuration for CoffeeIn Admin Panel
 * 
 * This configuration allows images to be served via Cloudflare CDN
 * for improved performance and reduced direct blob storage calls.
 */

export const CDN_CONFIG = {
  baseUrl: 'https://cdn.coffeein.club',
};

/**
 * Converts a relative path or full URL to a CDN URL
 * @param path - Relative path (e.g., "users/123/profile.jpg") or full URL
 * @returns Full CDN URL or null if path is null/undefined
 */
export const getCdnUrl = (path: string | null | undefined): string | null => {
  if (!path) return null;
  
  // If already a full URL (http:// or https://), return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  return `${CDN_CONFIG.baseUrl}/${cleanPath}`;
};

/**
 * Helper to get CDN URL with fallback
 * @param path - Relative path or full URL
 * @param fallback - Fallback URL if path is null/undefined
 * @returns CDN URL or fallback
 */
export const getCdnUrlWithFallback = (
  path: string | null | undefined,
  fallback: string
): string => {
  return getCdnUrl(path) || fallback;
};

